import React, { useState, useEffect } from 'react';
import { LOGO_URL, NAV } from '../data/content';
import { Menu, X } from 'lucide-react';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', on);
    return () => window.removeEventListener('scroll', on);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all ${scrolled ? 'bg-white/85 backdrop-blur-md border-b border-[#293891]/10' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="ExcellenC" className="h-9 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map(n => (
            <a key={n.href} href={n.href} className="text-[13px] font-medium text-[#293891]/80 hover:text-[#E63329] transition-colors">{n.label}</a>
          ))}
        </nav>

        <a href="#fees" className="hidden md:inline-flex items-center gap-2 bg-[#E63329] hover:bg-[#c41d13] text-white text-[13px] font-semibold px-5 py-2.5 rounded-full transition-colors shadow-[0_10px_25px_-10px_rgba(230,51,41,0.6)]">
          <span className="dot"></span>Enroll Now
        </a>

        <button onClick={() => setOpen(!open)} className="lg:hidden text-[#293891]">
          {open ? <X size={26}/> : <Menu size={26}/>}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#293891]/10 px-6 py-4 flex flex-col gap-4">
          {NAV.map(n => (
            <a key={n.href} href={n.href} onClick={()=>setOpen(false)} className="text-sm font-medium text-[#293891]">{n.label}</a>
          ))}
          <a href="#fees" onClick={()=>setOpen(false)} className="bg-[#E63329] text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center">Enroll Now</a>
        </div>
      )}
    </header>
  );
}
